module.exports = __webpack_public_path__ + "static/media/macbook-pro-beside-papers-669619.1695b993.jpg";